<template>
  <div>
    <voucher-accumulate-points v-model="purchaseLimits.black_list" @update-blocks="updateBlocks" />
    <voucher-cpf-points-limit v-model="purchaseLimits.coupons_limit" @update-limits="updateBlocks" />
    <voucher-purchases-without-points />
  </div>
</template>

<script>
import { QUERY_POINTS_BLOCKS_CONFIGURATION, MUTATION_UPDATE_POINTS_BLOCKS_CONFIGURATION } from '../../../../graphql'
import { mapState } from 'vuex'
import VoucherAccumulatePoints from './VoucherAccumulatePoints.vue'
import VoucherCpfPointsLimit from './VoucherCpfPointsLimit.vue'
import VoucherPurchasesWithoutPoints from './VoucherPurchasesWithoutPoints.vue'

export default {
  name: 'VoucherCpfBlock',
  components: {
    VoucherAccumulatePoints,
    VoucherCpfPointsLimit,
    VoucherPurchasesWithoutPoints,
  },
  data: () => ({
    purchaseLimits: {
      black_list: {
        active: true,
      },
      coupons_limit: {
        active: true,
        limit_per_day: 0,
      },
    },
  }),
  computed: {
    ...mapState(['smartClientId']),
    getDefaultPurchaseLimit() {
      const { id_external } = this.$getLoggedUser()
      return id_external === this.smartClientId ? 3 : 2
    },
    queryPurchaseLimit() {
      return QUERY_POINTS_BLOCKS_CONFIGURATION
    },
  },
  mounted() {
    this.getPurchaseLimit()
  },
  methods: {
    queryExtraArgs() {
      const extraArgs = {}
      return extraArgs
    },
    async updateBlocks(alertText) {
      try {
        await this.$apollo.mutate({
          mutation: MUTATION_UPDATE_POINTS_BLOCKS_CONFIGURATION,
          variables: {
            blackList: {
              active: true,
            },
            couponsLimit: {
              active: true,
              limit_per_day: this.purchaseLimits.coupons_limit.limit_per_day,
            },
          },
        })
        this.$snackbar({ message: alertText, snackbarColor: 'success' })
      } catch (error) {
        this.$snackbar({ message: 'Erro ao salvar configurações de limite.', snackbarColor: 'error' })
      }
    },
    async getPurchaseLimit() {
      await this.$apollo
        .query({
          query: this.queryPurchaseLimit,
          fetchPolicy: 'no-cache',
          ...this.queryExtraArgs(),
        })
        .then(({ data }) => {
          const {
            coupons_limit: { limit_per_day },
          } = data.pointsDiscountsBlocksConfiguration
          const limitPerDay = limit_per_day ?? this.getDefaultPurchaseLimit

          this.purchaseLimits.coupons_limit.limit_per_day = limitPerDay
          this.purchaseLimits.coupons_limit.active = true
          this.purchaseLimits.black_list.active = true
        })
        .catch(() => {
          this.$snackbar({ message: 'Erro ao buscar limite de pontos.', snackbarColor: 'error' })
        })
    },
  },
}
</script>

<style lang="scss">
.text-field-width {
  max-width: 300px;
}
</style>
